// Lightweight GA4/Google Ads event helpers.
// The gtag script is loaded in index.html. Events flow to GA4 via the linked
// Google Ads tag and any GA4 configuration inherited from it. All helpers
// are safe to call before gtag is ready (falls back to a no-op).

type Gtag = (...args: unknown[]) => void;

function gtag(...args: unknown[]): void {
  if (typeof window === 'undefined') return;
  const w = window as unknown as { gtag?: Gtag; dataLayer?: unknown[] };
  if (typeof w.gtag === 'function') {
    w.gtag(...args);
  } else {
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push(args);
  }
}

const DOC_PACK_ITEM = {
  item_id: 'iso27001-doc-pack',
  item_name: 'ISO 27001 Document Pack',
  item_category: 'digital-product',
  price: 99,
  quantity: 1,
};

export function trackDocPackViewItem(): void {
  gtag('event', 'view_item', {
    currency: 'USD',
    value: 99,
    items: [DOC_PACK_ITEM],
  });
}

export function trackDocPackBeginCheckout(): void {
  gtag('event', 'begin_checkout', {
    currency: 'USD',
    value: 99,
    items: [DOC_PACK_ITEM],
  });
}

export function trackDocPackPurchase(
  transactionId: string,
  value = 99,
  currency = 'USD',
): void {
  // Dedupe: guarantee both GA4 purchase and Ads conversion fire at most once
  // per LS order id (LS success can arrive via postMessage AND Setup handler).
  if (typeof window !== 'undefined') {
    const w = window as unknown as { __docPackPurchaseFired?: Set<string> };
    w.__docPackPurchaseFired = w.__docPackPurchaseFired || new Set<string>();
    if (w.__docPackPurchaseFired.has(transactionId)) return;
    w.__docPackPurchaseFired.add(transactionId);
  }

  gtag('event', 'purchase', {
    transaction_id: transactionId,
    currency,
    value,
    items: [{ ...DOC_PACK_ITEM, price: value }],
  });

  // Google Ads production Purchase conversion.
  gtag('event', 'conversion', {
    send_to: 'AW-18189289245/G6fwCLGz4c8cEJ2OquFD',
    transaction_id: transactionId,
    currency,
    value,
  });
}